/*
 * @Author: ylq
 * @Date: 2022-09-27 18:55:18
 * @Desc: api基础包
 * @Last Modified by:   ylq
 * @Last Modified time: 2022-09-27 18:55:18
 */
import { axios } from '@/utils/axios';

export class BaseService {
  /**
   * 项目接口 request
   * @type {{
   * url:string,method:string,data:any,params:any,headers?:object,
   * get:(url:string,config:import('axios').AxiosRequestConfig)=>Promise<{error:{msg:string,code:0|number,},data:any}>,
   * post:(url:string,data:any,config:import('axios').AxiosRequestConfig)=>Promise<{error:{msg:string,code:0|number,},data:any}>,
   * put:(url:string,data:any,config:import('axios').AxiosRequestConfig)=>Promise<{error:{msg:string,code:0|number,},data:any}>
   * delete:(url:string,config:import('axios').AxiosRequestConfig)=>Promise<{error:{msg:string,code:0|number,},data:any}>
   * }}
   */
  request = axios;
}
